module.exports = new __parcel__URL__("whiteboard-icon.f6879358.svg").toString();